/**
 * SensaTruth adapter — IOT-ADAPTER-LIBRARY-1.
 *
 * Tier: third-party-tier-3 (specialist cold-chain / quality monitoring)
 * Category: cold_chain, asset_tracker
 *
 * TYPE-ONLY: capability matrix declared; live API calls throw
 * VendorNotIntegratedError. Full integration scheduled once SensaTruth
 * partner-API credentials are provisioned.
 *
 * Supported devices: SensaTruth multi-sensor loggers (temperature, humidity,
 * shock, light, tilt). Cloud-only alerting; cellular and BLE variants.
 *
 * Patent anchor: F-IOT-ADAPTER-001.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const SENSATRUTH_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [30, 3600],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Telemetry reporting interval',
    },
    temp_alert_max_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Upper temperature alert threshold',
    },
    temp_alert_min_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Lower temperature alert threshold',
    },
  },
  telemetryTypes: [
    'temperature_c', 'humidity_pct', 'shock_g', 'light_lux', 'tilt_deg',
    'gps_position', 'battery_soc_pct',
  ],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 30_000,
};

export class SensaTruthAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'sensatruth', SENSATRUTH_CAPABILITIES);
  }
}

export function createSensaTruthAdapterFactory() {
  return (device) => new SensaTruthAdapter(device);
}
